export const browserName = ['시스템 기본 브라우저','크롬','사파리', '삼성','네이버']

export const Browser = {
    Default: 'Default' as const,
    Chrome: 'Chrome' as const,
    Safari: 'Safari' as const,
    Samsung: 'Samsung' as const,
    Naver: 'Naver' as const
} as const;

export type ContentBrowser = typeof Browser[keyof typeof Browser];